import axios from '../axios'



export const openDoorList = (data) => {
    return axios({
        
        url:'/admin/service/unlock_list',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/openDoor.js